
import { Component, Vue } from "vue-property-decorator";
import Template from "@/views/system-management/template/index.vue";
import {
  deleteOrderLibrary,
  deleteQuoteLibrary,
  deleteTask,
  downloadExl,
  searchTaskList,
  viewTaskLog,
  downloadViewTaskLog
} from "@/api/task-management";
import Pagination from "@/components/Pagination/index.vue";
import { Message } from "element-ui";
import { updateProductNumbeXia } from "@/api/order-library"; // 下单库
import { updateProductNumbeBao } from "@/api/quote-library"; // 报价库
import XTerm from "./components/xterm.vue";

@Component({
  name: "TaskManagement",
  components: { Template, Pagination,XTerm },
})
export default class extends Vue {
  private listQuery = {
    type: "inquiryLibrary",
    fileName: null,
    page: 1,
    size: 20,
    taskName: null,
    startTime: null,
    endTime: null
  };

  private create: string;
  private uploadID: string;
  private files: any[] = [];
  private total: Number = 0;
  private taskList: [] = [];
  private documentTypes = [
    { value: "inquiryLibrary", label: "询价单" },
    { value: "quoteLibrary", label: "报价库" },
    { value: "orderLibrary", label: "下单库" },
    { value: "claimForm", label: "索赔单" },
  ];

  public logInfoFields = [
    {
      label: "任务名称",
      key: "taskName",
    },
    {
      label: "任务状态",
      key: "state",
    },
  ] as any;
  public logInfo = {} as any;
  private logData = 'logging--------------------logging\n';

  private taskProgressList = [ // test 任务阶段进度
    {
      percentage: 30
    },
    {
      percentage: 70
    },
    {
      percentage: 100
    }
  ] as any;

  created() {
    this.getList();
  }

  public async handleErrorFile(row) {
    this.uploadID = row.id;
    this.$confirm("", "提示", {
      confirmButtonText: "上传",
      cancelButtonText: "下载",
      distinguishCancelAndClose: true,
      type: "warning",
    })
      .then(async () => {
        // 上传文件
        this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
        this.getList();
      })
      .catch((err) => {
        if (err === "cancel") {
          // 下载文件
          this.downloadErrorFile(row.libraryOssUrl);
          this.getList();
        }
      });
  }
  customColorMethod(percentage) {
    if (percentage < 30) {
      return '#909399';
    } else if (percentage < 70) {
      return '#e6a23c';
    } else {
      return '#67c23a';
    }
  }
  private async reUploadTask(
    id: string,
    type: string,
    customerId: string,
    customerAbbr: string
  ) {
    if (type === "orderLibrary") {
      await deleteOrderLibrary(id);
    }
    if (type === "quoteLibrary") {
      await deleteQuoteLibrary(id);
    }
    this.$router.push({
      name: "EnquiryFormManagement",
      query: {
        type: type,
        customerId: customerId,
        customerAbbreviation: customerAbbr,
      },
    });
  }

  private async getList() {
    const { total, list }: any = await searchTaskList(this.listQuery);
    this.total = parseInt(total);
    this.taskList = list;
  }

  private addFile(file: any) {
    if (file.size / 1024 / 1024 >= 10) {
      Message({
        message: "上传的文件大小不能超过10M!",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.files.push(file);
  }

  private async handleUpload() {
    if (this.files.length == 0) {
      return;
    }
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    if (this.listQuery.type == "quoteLibrary") {
      await updateProductNumbeBao(this.uploadID, formData).then(
        (result: any) => {
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000,
          });
        }
      );
    } else if (this.listQuery.type == "orderLibrary") {
      await updateProductNumbeXia(this.uploadID, formData).then(
        (result: any) => {
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000,
          });
        }
      );
    }
    this.files = [];
  }

  private async deleteTask(value) {
    await deleteTask(value).then(() => {
      this.$notify({
        title: "成功",
        message: "删除成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    });
  }

  private async downloadExcel(row) {
    await downloadExl(row.ossUrl).then((res) => {
      this.createFile(res, row.fileName);
    });
  }

  private downloadErrorFile(url) {
    window.open(url);
  }

  private createFile(res: any, fileName: string) {
    let blob = new Blob([res.data]);
    let downloadElement = document.createElement("a");
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }

  private showViewLog = false;
  private start = 0; // 起始位置
  private length = 20; // 请求日志数量
  private intervalId; // 定时器id
  private logTotal = 0;
  private reLogLoading = false;
  private logID = ''; // 任务ID
  private errRemark = ''; // 错误备注
  private errTaskName = ''; // 错误备注任务名称
  private async viewLog(row) {
    this.logID = row.id
    this.errRemark = row.remark?row.remark:''
    this.errTaskName = row.taskName
    this.logInfo = row
    this.showViewLog = true;
    this.$nextTick( async () => {
      await (this.$refs.logTerm as any).initTerm();
      this.intervalId = setInterval( async() => {
        if(this.reLogLoading) {
          return
        }
        let params = {
          taskId: row.id,
          length: this.length,// 日志数量
          start:this.start
        }
        await viewTaskLog(params).then((res:any) => {
          res.logs.forEach(item => {
            (this.$refs.logTerm as any).wirteLog(`${item}\n`)
          })
          this.logTotal = res.total
          if(res.state === 'FINISH') {
            if(Number(res.total) > (this.start + this.length)) {
              this.start = this.start + this.length
            } else {
              this.$notify({
                title: "提示",
                message: "日志输出完毕！",
                type: "success",
                duration: 2000,
              });
              clearInterval(this.intervalId)
            }
          } else {
            if(res.total === '0') {
              this.$notify({
                title: "提示",
                message: "当前日志为空！",
                type: "warning",
                duration: 2000,
              });
              clearInterval(this.intervalId);
            } else {
              this.start = this.start + this.length
            }
          }
        }).catch(err => {
          console.log(err);
          clearInterval(this.intervalId);
        })
      },1000)
    })
  }

  private async reLog() {
    if( Number(this.logTotal) !== 0 && Number(this.logTotal) <= (this.start + this.length)) {
      this.$notify({
        title: "提示",
        message: "日志已经加载完毕！",
        type: "warning",
        duration: 2000,
      });
      return
    }
    if( Number(this.logTotal) === 0 ) {
      this.$notify({
        title: "提示",
        message: "当前日志为空！",
        type: "warning",
        duration: 2000,
      });
      return
    }
    this.reLogLoading = true;
    let params = {
      taskId: this.logID,
      length: this.length,// 日志数量
      start:this.start
    }
    await viewTaskLog(params).then((res:any) => {
      res.logs.forEach(item => {
        (this.$refs.logTerm as any).wirteLog(`${item}\n`)
      })
      this.logTotal = res.total
      if(res.state === 'FINISH') {
        if(Number(res.total) > (this.start + this.length)) {
          this.start = this.start + this.length
        } else {
          clearInterval(this.intervalId)
        }
      } else {
        this.start = this.start + this.length
      }
      this.reLogLoading = false;
    }).catch(err => {
      console.log(err);
      this.reLogLoading = false;
      clearInterval(this.intervalId);
    })
  }

  private logClose() {
    (this.$refs.logTerm as any).dispose();
    clearInterval(this.intervalId);
    this.start = 0;
    this.showViewLog = false;
  }

  private async downloadLogTxt() {
    await downloadViewTaskLog(this.logID).then(res => {
      this.$notify({
        title: "提示",
        message: "下载成功！",
        type: "success",
        duration: 2000,
      });
    }).catch(err => {
      console.log(err);
    })
  }
  private async downloadErrorLog() {
    let filename = `${this.errTaskName}-错误日志.txt`;
    let element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.errRemark));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}
